define((require) => {
    "use strict";

    const _                                         = require("underscore");
    const AbstractWidgetView                        = require("shared/ui/experience/widgets/AbstractWidgetView");
    const HtmlWidgetView                            = require("shared/ui/experience/widgets/htmlWidget/HTMLWidgetView");
    const Marionette                                = require("marionette");
    const ReactBridge                               = require("backbone.react-bridge");
    const HtmlWidget                                = require("shared/ui/experience/widgets/htmlWidget/HTMLWidgetComponent").default;
    const HtmlWidgetLayout  = Marionette.Layout.extend({

        template: () => "<div class=\"html-widget placeholder\"></div>",

        regions: {
            "html-widget": ".html-widget"
        }

    });

    /**
     * Mixin the editor related logic for the HtmlWidgetView
     *
     * @see  HtmlWidgetView
     */
    return HtmlWidgetView.mixin("HtmlWidgetViewEditorMixin", {

        _layout: null,

        className: `${AbstractWidgetView.prototype.className} html-widget`,

        // This gives us access to the proper this context
        getPropsFromView: (self) =>
            ({
                onChange: (text) => {
                    self.model.set("htmlText", text);
                },
                onSelect: (event) => {
                    const {options} = self;
                    // For some reason the selection is not updated to reflect the state of the editor surface.
                    const selectedWidgets = options.viewModel.selection.get("widgets");
                    const singleSelection = selectedWidgets.length < 2; // Not a group selection
                    const modifierKeyDown = event.shiftKey || event.ctrlKey || event.metaKey; // Same keys as in FreeTransform.js#down

                    if (singleSelection) {
                        if (modifierKeyDown) {
                            const newSelectedWidgets = _.uniq([self].concat(selectedWidgets));
                            options.viewModel.selection.select(newSelectedWidgets);
                        } else {
                            options.viewModel.selection.select([self]);
                        }
                    }
                },
                onDeselect: () => {},
                onMount: () => {}
            }),

        modelEvents: {},

        onRender() {
            const onRender = AbstractWidgetView.prototype.onRender;

            if (onRender) {
                onRender.apply(this, _.toArray(arguments));
            }
        },

        onShow() {
            this.__super();
        },

        showView() {
            this.__super();
            this._layout = new HtmlWidgetLayout({el: this.$el});
            this._layout.render();

            const scopedGetProps = ({
                model, selection, viewModel, parentScene
            }) => {
                const selectionWidgets = selection && selection.get("widgets");
                const viewModelSceneNumber = viewModel && viewModel.get("sceneNumber");
                const parentSceneNumber = parentScene && parentScene.get("sceneNumber");
                const isWidgetInActiveScene = viewModelSceneNumber === parentSceneNumber;

                return {
                    isSelected: isWidgetInActiveScene && selectionWidgets.some((widget) => widget.model === model),
                    readOnly: selection.isMultiple() || !isWidgetInActiveScene,
                    isTransforming: model.get("isTransforming"),
                    htmlText: model.get("htmlText")
                };
            };

            const htmlWidgetView = ReactBridge.viewFromComponent(HtmlWidget, {
                model: this.model,

                viewModel:  this.options.viewModel,

                selection:  this.options.viewModel.selection,

                parentScene: this.parentView.scene || this.parentView.model.get("scene"),

                observe: {
                    model: "change",
                    viewModel: "change",
                    selection: "change",
                    parentScene: "change"
                },

                // Passing in this so I have a reference to the backbone class.
                props: this.getPropsFromView(this),

                // The arguments here are from ReactBridge and NOT specifically our code.
                // This is the model specified in the config object.
                getProps: scopedGetProps
            });

            this._layout["html-widget"].show(htmlWidgetView);
        },

        onClose() {
            if (this._layout) {
                this._layout.close();
            }
        }

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/experience/widgets/htmlWidget/HtmlWidgetViewEditorMixin.js